module.exports = __webpack_public_path__ + "static/media/loader.ac0ed1dc.svg";